import Loading from "./loading.svg?react";

export function LoadingInput({classe}:any) {
  return <Loading className={classe}/>;
}
